import React, { memo } from 'react';
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { Checkbox } from '~/UIKit';
import { FilterItemsStyles } from './FilterItems.styles';

interface IFilterCheckboxList {
  selectItem: (id: any) => () => void;
  selectedMap: { [key: string | number]: boolean };
  list: { id: string; label: React.ReactNode; icon?: React.ReactNode }[];
}
export const FilterCheckboxList = memo(({ selectItem, selectedMap, list }: IFilterCheckboxList) => {
  const { classes } = FilterItemsStyles();

  return (
    <List className={classes.list}>
      {list.map(({ id, label, icon }) => (
        <ListItem key={id} disablePadding>
          <ListItemButton
            role={undefined}
            onClick={selectItem(id)}
            dense
            className={classes.listItem}
          >
            <ListItemIcon className={classes.listItemCheckboxContainer}>
              <Checkbox
                edge="start"
                checked={selectedMap[id] ?? false}
                tabIndex={-1}
                disableRipple
                inputProps={{ 'aria-labelledby': id }}
                className={classes.checkbox}
              />
            </ListItemIcon>
            {icon && <ListItemIcon className={classes.listItemIcon}>{icon}</ListItemIcon>}
            <ListItemText classes={{ primary: classes.titleText }} id={id} primary={label} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
});
